import React from "react";
import { Chart } from "react-google-charts";

export const StatisticChart = (props: any) => {
  const { data } = props;

  const options = {
    title: "",
    is3D: true,
    colors: ["#5a99d3", "#e97c30"],
    chartArea: { left: "5%", width: "100%", height: "100%" },
  };

  const dataName = [
    ["", ""],
    ["Số lượng người đã đọc", data ? data[1]?.soluong : 0],
    ["Số lượng người chưa đọc", data ? data[2]?.soluong : 100],
  ];

  return <Chart chartType="PieChart" data={dataName} width={"400px"} height={"400px"} options={options} />;
};
